import React from 'react';
import { Link } from 'react-router-dom';
import SpaceMonkeyLogo from '../../components/brand/SpaceMonkeyLogo';
import Icon from '../../components/brand/Icon';
import './SpaceMonkeyPage.css';

const SpaceMonkeyPage = () => {
  return (
    <div className="sm-page">
      <section className="sm-hero">
        <div className="sm-hero-inner">
          <div className="sm-hero-logo">
            <SpaceMonkeyLogo size="hero" tagline={false} />
          </div>

          <h1>Space Monkey Parking</h1>
          <p className="sm-hero-rule">
            Customers park free with validation. Other visitors can buy a parking permit.
          </p>

          <div className="sm-price-card">
            <div className="sm-price-row">
              <span>Parking permit</span>
              <span>$5.00</span>
            </div>
            <div className="sm-price-row">
              <span>Convenience fee</span>
              <span>$1.00</span>
            </div>
            <div className="sm-price-row sm-price-total">
              <span>Total charged</span>
              <span>$6.00</span>
            </div>
          </div>

          <div className="sm-cta-buttons">
            <Link to="/spacemonkey/validate" className="btn btn-success btn-lg sm-cta-btn">
              <Icon name="check" size={20} /> Validate Parking
            </Link>
            <Link to="/spacemonkey/pay" className="btn btn-primary btn-lg sm-cta-btn">
              <Icon name="ticket" size={20} /> Buy Parking Permit
            </Link>
          </div>
        </div>
      </section>

      <footer className="sm-footer">
        <span className="sm-footer-powered">Powered by RGV Smart Pay</span>
      </footer>
    </div>
  );
};

export default SpaceMonkeyPage;
